export enum UserListItemId {
  TargetUser = 'relatedSites',
  FilterAffiliate = 'relatedAffiliate',
  FilterCompanyGroup = 'relatedCompanyGroup',
  FilterCompany = 'relatedCompany',
  FilterTenant = 'relatedTenant',
  ShowUserDelete = 'showUserDelete',
}
